import styled from '@emotion/styled';
import {
    boxSizes,
    breakpoints,
    colors,
    colorVariables,
    fontWeights,
    gutterSizes,
    mediaQuery,
} from '../base/theme';

export const SelectModalTrigger = styled.button<{
    selectedDisplayName: string | undefined;
    isInvalid: boolean;
}>`
    && {
        border: 1px solid ${(props) => (props.isInvalid ? colors.red : colorVariables.borderLight)};
        border-radius: ${boxSizes.borderRadius4};
        color: ${(props) => (props.selectedDisplayName ? colors.bark : colors.bark60)};
        padding: ${gutterSizes.small} ${gutterSizes.base};
        box-sizing: border-box;
        height: 44px;
        width: 100%;
        text-align: left;
        position: relative;

        &:before {
            content: '';
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid ${colors.darkGrey};
            position: absolute;
            top: calc(50% - 3px);
            right: ${gutterSizes.medium};
        }
    }
`;

export const SearchableListFormRow = styled.div`
    width: 50%;
    padding: 0 ${gutterSizes.base} 0 0;

    ${mediaQuery.until(breakpoints.medium)} {
        width: 100%;
    }
`;

export const SearchableListFormLabel = styled.label`
    margin-bottom: 6px;
    font-weight: ${fontWeights.bolder};
    display: block;
`;

export const SkillsSelectModalTriggerWrapper = styled.div`
    margin: 0 0 ${gutterSizes.xxxxlarge} 0;
`;

export const SkillsSelectModalTrigger = styled.button<{
    isInvalid: boolean;
}>`
    && {
        border: 1px solid ${(props) => (props.isInvalid ? colors.red : colorVariables.borderLight)};
        border-radius: ${boxSizes.borderRadius4};
        color: ${colors.bark60};
        padding: ${gutterSizes.small} ${gutterSizes.base};
        box-sizing: border-box;
        height: 44px;
        width: 100%;
        text-align: left;
        position: relative;
    }

    &:before {
        content: '';
        width: 8px;
        height: 8px;
        border-right: 1.5px solid ${colors.bark60};
        border-top: 1.5px solid ${colors.bark60};
        position: absolute;
        top: calc(50% - 4px);
        right: ${gutterSizes.medium};
        transform: rotate(45deg)
    }
`;
